import axios from "axios";
import { API_BASE_URL } from "../config/config";

export const getUnreadMessageCount = (messages = []) =>
  messages.filter((message) => !message.read).length;

export const markUserNotificationsRead = async (token) => {
  await axios.post(
    `${API_BASE_URL}/messages/read`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const deleteUserNotification = async (token, notification) => {
  await axios.post(
    `${API_BASE_URL}/messages/delete`,
    {
      messageId: notification._id,
      message: notification.message,
      receivedAt: notification.receivedAt,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const clearUserNotifications = async (token) => {
  await axios.post(
    `${API_BASE_URL}/messages/clear`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
